module.exports = __webpack_public_path__ + "img/appCheck.f729f143.svg";